import { PRICING } from './pricingHookTranslationStrings';

export const getSubscriptionsTranslationText = (isMonthlyFirst: boolean, is36MonthsEnabled: boolean) => {
  const primaryMonthlyTranslationText = is36MonthsEnabled
    ? PRICING.STRING_36_MONTHLY
    : PRICING.STRING_48_MONTHLY;
  const secondaryMonthlyTranslationText = is36MonthsEnabled
    ? PRICING.STRING_36_MONTHLY_AS_SECONDARY_PRICE
    : PRICING.STRING_48_MONTHLY_AS_SECONDARY_PRICE;

  return isMonthlyFirst ? primaryMonthlyTranslationText : secondaryMonthlyTranslationText;
};
